import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { client } from '../../api/client'

const historyVarsAdapter = createEntityAdapter({
    selectId: vars => vars.Id
})

const initialState = historyVarsAdapter.getInitialState({
    status: 'idle',
    error: null
})

export const fetchHistoryVarsList = createAsyncThunk('vars/fetchHistoryVars', async (takeMonths) => {
    const response = await client.get('/VarTransactions/GetHistoryVarTransactions' + (takeMonths !== 99 && takeMonths !== null ? '?takeMonths=' + takeMonths : ''))
    return response.data
})

export const sendFinalisedPdf = createAsyncThunk('vars/sendFinalisedPdf', async (varId) => {
    const response = await client.get('/VarTransactions/SendFinalisedPdf?varTransactionId=' + varId)
    return response.data
})

export const sendExcel = createAsyncThunk('vars/sendExcel', async (obj) => {    
    const response = await client.get('/VarTransactions/SendExcel?takeMonths=' + obj.takeMonths + '&type=' + obj.type)
    return response.data
})

const historyVarsListSlice = createSlice({
    name: 'historyVars',
    initialState,
    reducers: {
        Reload(state) {
            historyVarsAdapter.removeAll(state)
            state.status = 'idle'
            state.error = null
        }
    },
    extraReducers: {
        [fetchHistoryVarsList.history]: (state, /*action*/) => {
            state.status = 'loading'
        },
        [fetchHistoryVarsList.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            historyVarsAdapter.addMany(state, action.payload)
        },
        [fetchHistoryVarsList.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        }
    }
})

export default historyVarsListSlice.reducer

export const {
    Reload
} = historyVarsListSlice.actions

export const {
    selectAll: selectAllHistoryVars,
    selectById: selectHistoryVarById,
    selectIds: selectHistoryVarIds,
} = historyVarsAdapter.getSelectors((state) => state.historyVars)